import { FC, PropsWithChildren } from 'react';
import { Spinner } from '../../../common/components';
import { useAlgorithmJoinsDataQuery } from '../joins/useAlgorithmJoinsDataQuery';
import { AlgorithmJoinsWithMappingsGraphFormModal } from '../joinsAndMappings/graph/AlgorithmJoinsWithMappingsGraphFormModal';

export interface JoinsAndMappingsPreviewModalProps extends PropsWithChildren {
  algorithmId: number;
  onClose?: () => void;
}

export const JoinsAndMappingsPreviewModal: FC<
  JoinsAndMappingsPreviewModalProps
> = (props) => {
  const { algorithmId, onClose } = props;

  const { data, isFetching } = useAlgorithmJoinsDataQuery(algorithmId);

  if (isFetching) {
    return <Spinner overlay delay={200} />;
  }

  if (!data) {
    return null;
  }

  return (
    <AlgorithmJoinsWithMappingsGraphFormModal
      readOnly
      mappings={data.mappings}
      joins={data.joins}
      sources={data.sources}
      sourceDimensionsMap={data.sourceDimensionsMap}
      onClose={onClose}
    />
  );
};
